import { SolutionStrategyTag } from "@/design-system/Tags/SolutionTag/SolutionTag";
import { SolutionFacts } from "@repo/shared/utils";

/**
 * One squad in an alternatives list, whatever solved it: the Streamline page
 * adapts its solutions to this, the normal solution page its pool entries.
 */
export type AlternativeRow = {
  id: string;
  /** Every strategy that found this squad; what the greyed rows are worked out from. */
  tags: SolutionStrategyTag[];
  /** The pills to draw, when not every tag holds as a label. Defaults to `tags`. */
  shownTags?: SolutionStrategyTag[];
  recommended: boolean;
  facts: SolutionFacts;
};

/** The strategies the solver found nothing for, shown greyed after the rows. */
export const missingTags = (
  rows: AlternativeRow[],
  allTags: SolutionStrategyTag[],
): SolutionStrategyTag[] =>
  allTags.filter((tag) => !rows.some((row) => row.tags.includes(tag)));
